import React, { useState, useEffect } from 'react';

import './Gallery.css'

const Gallery = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchGalleryItems();
  }, []);

  const fetchGalleryItems = async () => {
    try {
      const response = await fetch('https://admin.granasialife.com/api/gallerys');
      const data = await response.json();
      setGalleryItems(data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching gallery items:', error);
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h2 className="text-center mb-5">Gallery</h2>
      <div className="row">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status"></div>
            <br />
            Loading Gallery...
          </div>
        ) : (
          galleryItems.map((item) => (
            <div className="col-md-4 mb-4" key={item.id}>
              <div className="card h-100 shadow">
              <div
              className="gallery-image"
              style={{
                backgroundImage: `url(${item.image_url.startsWith('http') ? item.image_url : `https://granasialife.com${item.image_url}`})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "250px",
                position: "relative",
                cursor: "pointer",
              }}
              onMouseEnter={() => setSelectedImage(item.id)}
              onMouseLeave={() => setSelectedImage(null)}
            >
            
                  {selectedImage === item.id && (
                    <div className="image-overlay">
                      <h5 className="text-white">{item.title}</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Gallery;
